import React, { useContext, useEffect, useState } from "react";
import { ToastContext } from "../../component/global/ToastContext";
import Skeleton from "react-loading-skeleton";
import {
    addBookmark,
    disLikeFeedback,
    likeFeedback,
    removeBookmark,
} from "../../controlers/messages/FeedbackController";
import moment from "moment-jalaali";
import AlertBox from "../../component/global/AlertBox";
import IconBox from "../../component/global/IconBox";
import StarRatings from "react-star-ratings";
import { getTextDigest } from "../../utils/methods";
import { ReactComponent as Bookmark } from "../../asset/icons/bookmark.svg";
import { ReactComponent as BookmarkFill } from "../../asset/icons/bookmark-fill.svg";
import { ReactComponent as DateIcon } from "../../asset/icons/dateIcon.svg";
import { ReactComponent as ClockIcon } from "../../asset/icons/clockIcon.svg";
import { ReactComponent as SpeakerIcon } from "../../asset/icons/speakerIcon.svg";
import UserPic from "../../asset/image/just-logo.png";
import { useTranslation } from "react-i18next";
import MessageStatusBadge from "./MessageStatusBadge";

export default function FeedbackItem({
    id,
    item,
    user,
    computed_score,
    description,
    datetime,
    bookmark: initialBookmark,
    onItemClick,
    file,
    feedback_status,
}) {
    const [bookmark, setBookmark] = useState(initialBookmark);
    const show = useContext(ToastContext);
    const [like, setLike] = useState(false);
    const [dislike, setDislike] = useState(false);
    const [lasting, setLasting] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        if (datetime) {
            let d = new Date(datetime).getTime();
            let differ = Math.round((Date.now() - d) / 1000);
            if (differ < 0) differ = 0;
            let hour = Math.floor(differ / 3600);
            let minute = Math.floor((differ % 3600) / 60);

            setLasting(
                (hour < 10 ? "0" + hour : hour) +
                    ":" +
                    (minute < 10 ? "0" + minute : minute)
            );
        }
    }, [lasting, datetime]);

    if (id === undefined) {
        return (
            <div
                className="col col-sm-6 col-md-4 col-lg-4 col-xl-3 user_message_column"
                style={{ minWidth: 220 }}
            >
                <Skeleton count={1} style={{ fontSize: 300 }} />
            </div>
        );
    }
    // const file = item.file;       //there is no profile picture in API yet
    const handleLikeClick = (event) => {
        event.stopPropagation();
        likeFeedback(id).then(() => {
            show(t("Src.Pages.Messages.FeedbackItem.Label"), "success");
            setLike(false);
            setDislike(true);
        });
    };

    const handleDisLikeClick = (event) => {
        event.stopPropagation();
        disLikeFeedback(id).then(() => {
            show(t("Src.Pages.Messages.FeedbackItem.Label"), "success");
            setLike(true);
            setDislike(false);
        });
    };

    const handleAddBookmark = (event) => {
        event.stopPropagation();
        addBookmark(id).then((response) => {
            setBookmark(response);
        });
    };

    const handleRemoveBookmark = (event) => {
        event.stopPropagation();
        removeBookmark(bookmark.id, id).then(() => {
            setBookmark(false);
        });
    };

    return (
        <div className="col col-sm-6 col-md-4 col-lg-4 col-xl-3 user_message_column">
            <div className="user_message_box" onClick={() => onItemClick(id)}>
                <div className="user_info">
                    <div className="right">
                        {file ? (
                            <img src={file} className="user_image" alt="user" />
                        ) : (
                            <img
                                src={UserPic}
                                className="user_image"
                                alt="user"
                            />
                        )}

                        <div className="user_detail">
                            <span className="name">
                                {user?.first_name || user?.last_name
                                    ? user.first_name + " " + user.last_name
                                    : t(
                                          "Src.Pages.Messages.FeedbackItem.Guest.User.Label"
                                      )}
                            </span>
                            <span dir="ltr" style={{ transform: "scaleX(-1)" }}>
                                <StarRatings
                                    rating={computed_score}
                                    starDimension="20px"
                                    starSpacing="0px"
                                    starRatedColor="rgb(254, 183, 48)"
                                    starEmptyColor="#ccc"
                                />
                            </span>
                        </div>
                    </div>
                    <div className="left">
                        <div className="icon_component_box">
                            {bookmark && (
                                <BookmarkFill onClick={handleRemoveBookmark} />
                            )}
                            {!bookmark && (
                                <Bookmark onClick={handleAddBookmark} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="desc">{getTextDigest(description)}</div>
                <div className="message-card-status">
                    <MessageStatusBadge status={feedback_status} />
                </div>
                <div className="details">
                    <div className="details_box">
                        <div className="right">
                            <DateIcon />
                            <span className="details_title">
                                {t(
                                    "Src.Pages.Messages.FeedbackItem.Date.Label"
                                )}
                            </span>
                        </div>
                        <span className="details_value">
                            {moment(datetime).format("jYYYY/jMM/jDD")}
                        </span>
                    </div>
                    <div className="details_box">
                        <div className="right">
                            <ClockIcon />
                            <span className="details_title">
                                {t(
                                    "Src.Pages.Messages.FeedbackItem.Time.Label"
                                )}
                            </span>
                        </div>
                        <span className="details_value">
                            <span className="date_type">
                                {moment(datetime).format("HH:mm")}
                            </span>
                        </span>
                    </div>
                    <div className="details_box">
                        <div className="right">
                            <SpeakerIcon />
                            <span className="details_title">
                                {t(
                                    "Src.Pages.Messages.FeedbackItem.Item.Label"
                                )}
                            </span>
                        </div>
                        <span className="details_value" title={item?.name}>
                            {item?.name}
                        </span>
                    </div>
                </div>
                <div className="actions">
                    <div className="actions_box">
                        {/* <IconBox
                            iconName="disLikeIcon"
                            specialClass={
                                "red_box" + (dislike ? " active" : "")
                            }
                            clickFunction={handleLikeClick}
                            svg={true}
                        /> */}
                        {/* <IconBox
                            iconName="likeIcon"
                            specialClass={
                                "light_green_box" + (like ? " active" : "")
                            }
                            clickFunction={handleDisLikeClick}
                            svg={true}
                        /> */}
                    </div>
                    <div className="left">
                        <AlertBox />
                        <span className="time_box">{lasting}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
